import {
  Box,
  FormControl,
  FormControlProps,
  InputBaseProps,
  TextField,
} from "@mui/material";
import { SxProps } from "@mui/system";
import {
  Controller,
  FieldErrors,
  FieldValues,
  UseControllerProps,
} from "react-hook-form";
import { getError } from "../../../../utils/common";
import styles from "./styles";
import InputErrorText from "./InputErrorText";

type InputProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<FormControlProps, "onChange"> &
  InputBaseProps & {
    label?: string;
    errors?: FieldErrors;
    outsideError?: string;
    maxLength?: number;
    customStyles?: { [key: string]: SxProps };
    additionalInfo?: string;
    view?: boolean;
    value?: any;
    noUseFieldValue?: boolean;
    onEmailChange?: any;
    onPhoneChange?: any;
    onTaxNumber?: any;
    loading?: boolean;
    placeholder?: string;
    placeholderPopup?: boolean;
  };

const Input = <T extends FieldValues>({
  name,
  control,
  label,
  type = "text",
  fullWidth = true,
  errors,
  maxLength = 50,
  rules,
  customStyles,
  onEmailChange = () => {},
  onPhoneChange = () => {},
  onTaxNumber = () => {},
  placeholder = "",
  placeholderPopup = false,
  value = "",
  disabled = false,
  noUseFieldValue = false,
  inputProps,
  variant = "standard",
  className,
  additionalInfo,
  view = false,
  loading = false,
  outsideError,
  ...rest
}: InputProps<T>) => {
  const error = getError(name, errors);
  const showPlaceholderPopup = placeholderPopup && placeholder?.length > 40;

  return (
    <Controller
      render={({ field }) => (
        <FormControl
          sx={{ ...customStyles?.input } as SxProps}
          fullWidth={fullWidth}
          variant={variant}
          className={className}
        >
          {label && (
            <>
              <Box
                className={
                  label.length > 43
                    ? "truncate_overflow input_label"
                    : "input_label"
                }
                sx={styles.label}
              >
                {label}
              </Box>
              {label.length > 30 && <Box className="popup_data">{label}</Box>}
            </>
          )}
          <TextField
            type={type}
            value={noUseFieldValue ? value : value ? value : field.value}
            onChange={(e) => {
              onEmailChange(e);
              onPhoneChange(e);
              onTaxNumber(e);
              field.onChange(e);
            }}
            className={showPlaceholderPopup ? "truncate_overflow" : ""}
            placeholder={placeholder}
            inputRef={field.ref}
            onBlur={field.onBlur}
            inputProps={{
              maxLength: maxLength,
              sx: { textOverflow: "ellipsis" },
              ...inputProps,
            }}
            error={!!error || !!outsideError}
            disabled={disabled}
            {...rest}
          />
          {showPlaceholderPopup && (
            <Box className="popup_data">{placeholder}</Box>
          )}
          <InputErrorText error={error?.message ?? outsideError} />
        </FormControl>
      )}
      name={name}
      control={control}
      rules={rules}
      {...rest}
    />
  );
};
export default Input;
